import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { ImagesEffects } from './+state/images.effects'
import { ImagesFacade } from './+state/images.facade'

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([ImagesEffects])],
  providers: [ImagesFacade],
})
export class GbDashboardSharedDataAccessImagesModule {}
